// Pausa de sistema (VOC-499): id fixo 25, contrato compartilhado entre os repos do VonixCC.
// Módulo puro: sem Vue/Quasar, para ser importado direto pelos testes (node --test).
export const SYSTEM_PAUSE_REASON_ID = 25

const PAUSED = 'PAUSED'
const VOICE = 'VOICE'
const CALL_STATUSES = ['DIALING', 'RINGING', 'ONTHEPHONE']

export const isSystemPauseId = (reasonId) => (
  reasonId !== null && reasonId !== undefined && reasonId !== '' && Number(reasonId) === SYSTEM_PAUSE_REASON_ID
)

// pauseReasonId não é limpo no unpause, então sempre combina com status.
export const isSystemPause = (agent) => Boolean(agent && agent.status === PAUSED && isSystemPauseId(agent.pauseReasonId))

export const isPauseLocked = (agent) => Boolean(agent && agent.paused && !isSystemPause(agent))

export const shouldDropChannels = (agent) => Boolean(agent && agent.status === PAUSED && !isSystemPause(agent))

// Atendimentos que seguram a pausa agendada. Para a volta para a 25 só voz conta;
// para as outras pausas mantém a regra antiga (voz ou texto fora de ONGOING).
export const countsForSchedulePause = (schedulePause) => (
  isSystemPauseId(schedulePause)
    ? ({ channel }) => channel === VOICE
    : ({ channel, status }) => channel === VOICE || status !== 'ONGOING'
)

export const hasAttendancesWithLock = ({ sessionCount, dialLocked }) => Boolean(dialLocked) || sessionCount > 0

export const canClearSchedulePause = ({ paused, schedulePause, dialLocked }) => Boolean(paused && schedulePause && !dialLocked)

export const shouldFallbackRepause = ({ prevStatus, status, schedulePause, hasVoiceSession, optionCallbackShow, alreadyFired }) => (
  CALL_STATUSES.includes(prevStatus) &&
  status === 'ONLINE' &&
  isSystemPauseId(schedulePause) &&
  !hasVoiceSession &&
  !optionCallbackShow &&
  !alreadyFired
)

// Motivo da pausa ao receber o SIP Agent. A central nem sempre manda PauseReason; quando falta,
// vale o motivo que o próprio Phone pediu no *11*N. Agent repetido sem motivo durante a mesma
// pausa mantém o que já havia; entrada em pausa sem motivo conhecido vira null (pausa comum).
export const resolvePauseReasonId = ({ status, sipReasonId, prevStatus, prevReasonId, requestedReasonId }) => {
  if (status !== PAUSED) return prevReasonId
  if (sipReasonId !== null && sipReasonId !== undefined && sipReasonId !== '') return sipReasonId
  if (requestedReasonId !== null && requestedReasonId !== undefined) return requestedReasonId
  return prevStatus === PAUSED ? prevReasonId : null
}

export const shouldIgnoreJourneyPrePause = ({ agent, schedulePause }) => Boolean(agent && agent.status === PAUSED) || isSystemPauseId(schedulePause)
